import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BuyerService } from '../../buyer/services/buyer.service';
import { UserRegistrationService } from '../services/user-registration.service';

@Injectable({
  providedIn: 'root',
})
export class AccountDetailsResolver implements Resolve<any> {
  private readonly logger = inject(NGXLogger);


  constructor(private userRegistrationService: UserRegistrationService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.userRegistrationService.getAccountDetails().pipe(
      tap((response) => {
        this.logger.debug(`AccountDetailsResolver response is ${JSON.stringify(response)}`)
      }),
      catchError((error) => {
        this.logger.error(`AccountDetailsResolver error is ${JSON.stringify(error)}`);
        // A plain "not logged in" (401) isn't a server crash — confirmed live 2026-09-06: a
        // freshly-invited user clicking "Complete Setup" from the welcome email (no session in
        // that browser) landed here, got a 401, and was dumped on a blank /error/server-error
        // page instead of being asked to log in. Same postLoginReturnUrl handoff AuthSessionGuard
        // already uses, so login sends them straight back into account-setup afterward.
        if (error?.status === 401) {
          localStorage.setItem('postLoginReturnUrl', this.router.url);
          this.router.navigate(['/login']);
          return of(null);
        }
        // '/error' isn't a real route (only error/forbidden, error/unusual, error/server-error
        // are) — it fell through to the ** wildcard and rendered a confusing 404 on any genuine
        // failure. OfflineGuard on this route's canActivate now prevents this resolver from
        // running at all when offline; this covers the remaining online-failure case.
        this.router.navigate(['/error/server-error']);
        return of(null);
      })
    );
  }
}